import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface SearchLensIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function SearchLensIcon({ color = RoutalPalette.primary40, style = {} }: SearchLensIconProps) {
  return (
    <SvgIcon viewBox="0 0 16 16" style={{ height: `16px`, width: `16px`, ...style }}>
      <g fill="none">
        <path
          d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M14 14.0001L11.1 11.1001" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  );
}
